import { Model } from './model';

export type CashAppGuidelineType = 'transaction' | 'remittance' | 'statement';

export class CashAppGuideline extends Model {
  id: string;

  content: string;

  applies_to: CashAppGuidelineType[];

  organization_id: string;
}
